import { styled } from "@woba/ds-web";

export const IconWrapper = styled("div", {
  padding: "$space-03",
  backgroundColor: "$neutral-200",
  display: "flex",
  borderRadius: "$sm",
});

export const ContentWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  flex: 1,

  h5: {
    textTransform: "uppercase",
    fontSize: "$xs",
    fontWeight: "500",
    color: "$neutral-700",
  },
});
